import { render, staticRenderFns } from "./Tawkto.vue?vue&type=template&id=9d2cbf38&"
import script from "./Tawkto.vue?vue&type=script&lang=js&"
export * from "./Tawkto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports